export const pad = (minutes, countSymbols = 2) => (`00000000${minutes}`).slice(-1 * countSymbols)

export const fullTime = (hours, minutes) => `${pad(hours)}:${pad(minutes)}`

export const convertDateToString = date => {
    const dateObject = new Date(date * 1000)
    return `${fullTime(dateObject.getHours(), dateObject.getMinutes())} ${dateObject.toLocaleDateString()}`
}
